import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

import { List, PillAction, Popper, Spinner } from '@xsolla/ui-core';
import { Plus } from '@xsolla/ui-icons';

import { LoginType } from '../../../api/dasboard/types';
import {
  BABKA_LOGIN_PROJECT_TYPE,
  MASTER_PROJECT_TYPE,
  SHADOW_PROJECT_TYPE
} from '../../../constants';
import { useConfig } from '../../../contexts/config';
import { useProjects } from '../../../contexts/settings';
import { useNotifications } from '../../../hooks/useNotifications';
import { usePaths } from '../../../routes/routesHelper';
import { VerticalCenterBlock } from '../../../styled';

type Props = RouteComponentProps & {
  babkaLoginProject: boolean;
  openCreateModal: () => void;
};

const CreateLoginButton = ({ history, babkaLoginProject, openCreateModal }: Props): JSX.Element => {
  const { navigationPath } = usePaths();
  const intl = useIntl();
  const { createProject, projects } = useProjects();
  const [fetching, setFetching] = useState<boolean>(false);
  const { xsollaAnalytics } = useConfig();
  const { showErrorNotify } = useNotifications();

  const createLogin = (loginType: LoginType) => {
    setFetching(true);

    const data = {
      type: loginType,
      name: `Login (${projects ? projects.length + 1 : 1})`,
      game_pages: [],
      description: ''
    };

    createProject(data)
      .then((res) => {
        xsollaAnalytics.sendOpen('login_pa_module__dashboard__create_login', 'success', {
          loginType: data.type,
          name: data.name
        });
        history.push({ pathname: navigationPath(res.id) });
      })
      .catch((err) => {
        showErrorNotify(err);
        xsollaAnalytics.sendOpen('login_pa_module__dashboard__create_login', 'error', {
          error: err.description,
          loginType: data.type
        });
      })
      .finally(() => setFetching(false));
  };

  const ListItems = [
    {
      children: intl.formatMessage({ id: 'dashboard.new-login.master' }),
      onClick: () => {
        createLogin(MASTER_PROJECT_TYPE);
      },
      'data-test-id': `btn-create-${MASTER_PROJECT_TYPE}`
    },
    {
      children: intl.formatMessage({ id: 'dashboard.new-login.shadow' }),
      caption: intl.formatMessage({ id: 'dashboard.new-login.shadow.description' }),
      onClick: () => {
        createLogin(SHADOW_PROJECT_TYPE);
      },
      'data-test-id': `btn-create-${SHADOW_PROJECT_TYPE}`
    },
    {
      children: intl.formatMessage({ id: 'dashboard.new-login.babka-login' }),
      onClick: () => {
        openCreateModal();
      },
      'data-test-id': `btn-create-${BABKA_LOGIN_PROJECT_TYPE}`
    }
  ];

  const PopperItems = (
    <List items={babkaLoginProject ? ListItems : ListItems.slice(0, ListItems.length - 1)} />
  );

  return (
    <div>
      {fetching ? (
        <Spinner />
      ) : (
        <Popper entry={PopperItems} placement="bottom-end">
          {(referenceProps) => (
            <PillAction {...referenceProps} data-test-id="btn-create-project" palette="brand">
              <VerticalCenterBlock>
                <Plus />
                {intl.formatMessage({ id: 'dashboard.new-login' })}
              </VerticalCenterBlock>
            </PillAction>
          )}
        </Popper>
      )}
    </div>
  );
};

export default withRouter(CreateLoginButton);
